// import axios from "axios";
// import useRefreshToken from "./useRefreshToken";

// const axiosPrivate = axios.create();

// const useAxiosPrivate = async () => {

//   console.log("test test test test test ---------------------------------------------->");
 
//   const refresh = useRefreshToken();
//   const access_token = sessionStorage.getItem("usr_1a2b3c");
//   const refresh_token = sessionStorage.getItem("usr_4d5e6f");

//   axiosPrivate.interceptors.request.use(
//     (config) => {
//       if (!config.headers["Authorization"]) {
//         config.headers["Authorization"] = `Bearer ${access_token}`;
//         config.headers["User-Refresh-Token"] = `${refresh_token}`;
//       }
//       return config;
      
//     },
//     (error) => Promise.reject(error)
//   );

//   axiosPrivate.interceptors.response.use(
//     async (response) => {
//        console.log("test test test test test ----------------------------------------------222222222>");
//       console.log('response:', response);
      
//       if(response?.data?.message?.detail == "Refresh token has already been blacklisted" &&  response?.data?.status_code === 500 ){
//         sessionStorage.clear();
//         window.location.href = "/login";
//       }
//       const originalRequest = response?.config;
//       if (response?.data?.status_code === 401 && !originalRequest?.sent) {
//         const newAccessToken = await refresh();
//         if (newAccessToken) {
//          sessionStorage.setItem("usr_1a2b3c", newAccessToken);
//           originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
//           originalRequest.headers["User-Refresh-Token"] = `${refresh_token}`;
//           return axiosPrivate(originalRequest);    
//         }
//       } else {
//         return response;
//       }
//     },

//     async (error) => {
//       console.log("error:", error);
//       return Promise.reject(error);
//     }
//   );

//   return axiosPrivate;
// };

// export default useAxiosPrivate;
// ----------------------------------------------------------------

import axios from "axios";
import useRefreshToken from "./useRefreshToken";
import { handleAccountDeactivated } from "../utils/accountDeactivated";

const axiosPrivate = axios.create();

const useAxiosPrivate = async () => {
  const refresh = useRefreshToken();
  const access_token = sessionStorage.getItem("usr_1a2b3c");
  const refresh_token = sessionStorage.getItem("usr_4d5e6f");
 
  axiosPrivate.interceptors.request.use(
    (config) => {
      if (!config.headers["Authorization"]) {
        config.headers["Authorization"] = `Bearer ${access_token}`;
        config.headers["User-Refresh-Token"] = `${refresh_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

 
  axiosPrivate.interceptors.response.use(
    (response) => {
      // Handle success response
      return response;
    },
    async (error) => {
      const originalRequest = error.config;

      // Account deactivated by an admin → force logout immediately. The gateway
      // returns 403 with error_code "ACCOUNT_DEACTIVATED" for every request once
      // the account is blocked.
      if (handleAccountDeactivated(error)) {
        return Promise.reject(error);
      }

      if (
        error?.response?.status === 401  && !originalRequest._retry // prevent infinite loop
      ) {
        originalRequest._retry = true;

        try {
          // Call refresh token API
          const newAccessToken = await refresh();

          if (newAccessToken) {
            // Save new token and retry request
            sessionStorage.setItem("usr_1a2b3c", newAccessToken.access_token);
            sessionStorage.setItem("usr_4d5e6f", newAccessToken.refresh_token);
            originalRequest.headers["Authorization"] = `Bearer ${newAccessToken.access_token}`;
            originalRequest.headers["User-Refresh-Token"] = `${newAccessToken.refresh_token}`;
            return axiosPrivate(originalRequest);
          }
        } catch (refreshError) {
          console.error("Refresh token failed:", refreshError);
          sessionStorage.clear();
          // window.location.href = "/";
        }
      }

      // ✅ Handle blacklisted token or invalid refresh token
      // if (
      //   error?.response?.data?.message?.detail ===
      //     "Refresh token has already been blacklisted" ||
      //   error?.response?.data?.message === "Invalid or expired refresh token"
      // ) {
      //   // sessionStorage.clear();
      //   window.location.href = "/";
      // }

      // Other errors
      return Promise.reject(error);
    }
  );

  return axiosPrivate;
};

export default useAxiosPrivate;


// import axios from "axios";
// import { useEffect } from "react";
// import useRefreshToken from "./useRefreshToken";

// const axiosPrivate = axios.create();

// const useAxiosPrivate = () => {
//   const refresh = useRefreshToken();

//   useEffect(() => {
//     const requestIntercept = axiosPrivate.interceptors.request.use(
//       (config) => {
//         const accessToken = sessionStorage.getItem("usr_1a2b3c");
//         const refreshToken = sessionStorage.getItem("usr_4d5e6f");

//         if (!config.headers["Authorization"]) {
//           config.headers["Authorization"] = `Bearer ${accessToken}`;
//           config.headers["User-Refresh-Token"] = refreshToken;
//         }
//         return config;
//       },
//       (error) => Promise.reject(error)
//     );

//     const responseIntercept = axiosPrivate.interceptors.response.use(
//       (response) => response,
//       async (error) => {
//         const originalRequest = error.config;

//         if (error?.response?.status === 401 && !originalRequest._retry) {
//           originalRequest._retry = true;

//           try {
//             const newToken = await refresh();

//             sessionStorage.setItem("usr_1a2b3c", newToken.access_token);
//             sessionStorage.setItem("usr_4d5e6f", newToken.refresh_token);

//             originalRequest.headers["Authorization"] =
//               `Bearer ${newToken.access_token}`;
//             originalRequest.headers["User-Refresh-Token"] =
//               newToken.refresh_token;

//             return axiosPrivate(originalRequest);
//           } catch (err) {
//             sessionStorage.clear();
//             window.location.href = "/";
//             return Promise.reject(err);
//           }
//         }

//         return Promise.reject(error);
//       }
//     );

//     // 🧹 Cleanup interceptors
//     return () => {
//       axiosPrivate.interceptors.request.eject(requestIntercept);
//       axiosPrivate.interceptors.response.eject(responseIntercept);
//     };
//   }, [refresh]);

//   return axiosPrivate;
// };

// export default useAxiosPrivate;
